import { render, staticRenderFns } from "./article.vue?vue&type=template&id=9f83499a&scoped=true"
import script from "./article.vue?vue&type=script&lang=js"
export * from "./article.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f83499a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f83499a')) {
      api.createRecord('9f83499a', component.options)
    } else {
      api.reload('9f83499a', component.options)
    }
    module.hot.accept("./article.vue?vue&type=template&id=9f83499a&scoped=true", function () {
      api.rerender('9f83499a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/article/article.vue"
export default component.exports